export default __webpack_public_path__ + "static/media/nftvideo2.9247a2c4.mp4";